import { Component } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../environments/environment";
import { AlertService } from "./share/service/alert.service";
import { Meta } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { PartnerService } from "./share/service/partner.service";
import { IPartnerDetail } from "./share/interface/partner.interface";
import { PartnerDataService } from "./share/service/partnerData.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html"
})
export class AppComponent {
  partnerCode: any;

  constructor(
    private metaService: Meta,
    activatedRoute: ActivatedRoute,
    swUpdate: SwUpdate,
    alertService: AlertService,

    translate: TranslateService
  ) {
    translate.addLangs(["en", "bm"]);
    translate.setDefaultLang("en");
    let browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|bm/) ? browserLang : "bm");

    // Get the root element
    if (environment.production) {
      swUpdate.available.subscribe((event) => {
        alertService.openSnackBar(
          "A newer version is now available. Refresh the page now to update the cache"
        );
        location.reload();
      });
      swUpdate.checkForUpdate();
    } else {
      this.metaService.updateTag({
        name: "robots",
        content: "noindex"
      });
    }
  }
}
